import { useCallback } from "react"
import { useAppDispatch } from "hooks/redux"
import { useDeleteInstance } from "resources/dashboard-instances"
import { removeInstanceFromStore } from "../store/remove-instance"

// Deletes a dashboard instance: server DELETE first, then the local store teardown that drains the
// instance's full per-dashboard footprint across every dashboard-scoped slice. removeInstanceFromStore
// drops each slice's [dashboardId] key directly, so no module list needs to be read here.
export function useRemoveInstance() {
  const dispatch = useAppDispatch()
  const deleteInstance = useDeleteInstance()

  return useCallback(
    async (instanceId: string) => {
      await deleteInstance(instanceId)
      // dashboardId === instanceId in the routed model; every slice is keyed by it.
      removeInstanceFromStore(dispatch, { instanceId, dashboardId: instanceId })
    },
    [deleteInstance, dispatch],
  )
}
